import {
  Autocomplete,
  Alert,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import {
  getActiveComplexForOrgOptions,
  getAllUnitOptions,
  getAssetOptions, getCourtOptions,
  getFacilityOptions,
  getVATAccount,
  getVendorExpenseAccountOptions,
  getVendorOptions,
  getWithholdingTaxAccount,
} from "../../services/list.service";
import {
  adjustForTimezone,
  formatCurrency,
  isAfterToday,
  isEmptyArray,
  isEmptyString,
  isNullUndefined,
  tryParseFloat,
} from "../../util/util";
import { ModalAcceptButton } from "../../constants/component.constants";
import Delete from "@mui/icons-material/Delete";
import { useSelector } from "react-redux";
import ModalContainerModule from "../modules/modalContainer";
import { ResponsiveRow } from "../../constants/layout.constants";
import { issueWarnMessage } from "../../actions/message";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

export default function CreateBill(props) {
  const user = useSelector((state) => state.auth.user);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [courtOptions, setCourtOptions] = useState([]);
  const [complexOptions, setComplexOptions] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [vendorExpenseAccountOptions, setVendorExpenseAccountOptions] = useState([]);
  const [assetOptions, setAssetOptions] = useState([]);
  const [vendorId, setVendorId] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [memo, setMemo] = useState("");
  const [vendorRefNo, setVendorRefNo] = useState("");
  const [applyToAsset, setApplyToAsset] = useState(false);
  const [applyToPropertyOrUnit, setApplyToPropertyOrUnit] = useState(true);
  const [applyToComplex, setApplyToComplex] = useState(false);
  const [applyToCourt, setApplyToCourt] = useState(false);
  const [applyToManagement, setApplyToManagement] = useState(false);
  const [propertyId, setPropertyId] = useState("");
  const [unitId, setUnitId] = useState("");
  const [asset, setAsset] = useState("");
  const [complex, setComplex] = useState("")
  const [court, setCourt] = useState("")
  const [completedForm, setCompletedForm] = useState(false);
  const [selectedBill, setSelectedBill] = useState(props.selectedBill);
  const [billItems, setBillItems] = useState([]);
  const [billItemTableRows, setBillItemTableRows] = useState("");
  const [billItemTotal, setBillItemTotal] = useState(0);
  const billItemsHash = useRef({});
  const VATAccountId = useRef("");
  const withholdingTaxAccountId = useRef("");

  useEffect(() => {
    if (user.proxyFacility == null) {
      return;
    }else{
      getCourtOptions(user.proxyFacility).then((courts) => {
        setCourtOptions(courts)
      })
    }
    if (
      props.task === "edit" &&
      selectedBill?.facility?.id != null &&
      !isEmptyString(String(selectedBill.facility.id))
    ) {
      return;
    }
    setPropertyId(user.proxyFacility);
  }, [user.proxyFacility, props.task, selectedBill]);

  function validateBillForm() {
    if (isNullUndefined(vendorId) || isEmptyString(vendorId)) {
      issueWarnMessage("Pay To is required");
      return false;
    }
    if (isNullUndefined(dueDate) || isEmptyString(dueDate)) {
      issueWarnMessage("Date is required");
      return false;
    }
    if (isAfterToday(dueDate)) {
      issueWarnMessage("Bill date cannot be a future date");
      return false;
    }
    if (isEmptyString(memo)) {
      issueWarnMessage("Memo is required");
      return false;
    }
    if (isEmptyArray(billItems) || billItems.length === 0) {
      issueWarnMessage("At least one bill item is required");
      return false;
    }
    for (let i = 0; i < billItems.length; i++) {
      const item = billItems[i];
      if (isNullUndefined(item.accountId) || isEmptyString(item.accountId)) {
        issueWarnMessage(`Expense Account is required for bill item ${i + 1}`);
        return false;
      }
      const amount = tryParseFloat(item.amount, -1);
      if (isNullUndefined(item.amount) || isEmptyString(item.amount) || amount <= 0) {
        issueWarnMessage(`Amount is required and must be greater than 0 for bill item ${i + 1}`);
        return false;
      }
    }
    if (applyToPropertyOrUnit) {
      if (isEmptyString(propertyId)) {
        issueWarnMessage("Property is required");
        return false;
      }
    } else if (applyToAsset) {
      if (isEmptyString(asset)) {
        issueWarnMessage("Asset is required");
        return false;
      }
    } else if (applyToComplex) {
      if (isEmptyString(complex)) {
        issueWarnMessage("Complex is required");
        return false;
      }
    }else if (applyToCourt) {
      if (isEmptyString(court)) {
        issueWarnMessage("Court is required");
        return false;
      }
    }
    return true;
  }

  const handleSave = () => {
    if (!validateBillForm()) {
      return;
    }
    let tmp = selectedBill;
    if (!isNullUndefined(propertyId) && !isEmptyString(propertyId)) {
      tmp.facility.id = propertyId;
    }
    if (!isNullUndefined(asset) && !isEmptyString(asset)) {
      tmp.asset.id = asset;
    }
    if (!isNullUndefined(unitId) && !isEmptyString(unitId)) {
      if (isNullUndefined(tmp.unit)) {
        tmp.unit = {};
      }
      tmp.unit.id = unitId;
    } else if (!isNullUndefined(tmp.unit)) {
      tmp.unit.id = null;
    }
    tmp.vendorId = vendorId;
    tmp.description = memo;
    tmp.vendorRefNo = vendorRefNo;
    tmp.dueDate = adjustForTimezone(new Date(dueDate));
    tmp.billItems = billItems;
    if(applyToComplex && !isNullUndefined(complex) && !isEmptyString(complex)) {
      tmp.complexId = complex
    }else{
      delete tmp.complexId;
    }
    if(applyToCourt && !isNullUndefined(court) && !isEmptyString(court)) {
      tmp.courtId = court
    }else{
      delete tmp.courtId;
    }

    if(applyToManagement) {
      tmp.applyToManagement = applyToManagement;
    }else{
      delete tmp.applyToManagement;
    }
    setSelectedBill(tmp);
    saveBill();
  };

  const handleApplyToChange = (e) => {
    setApplyToAsset(false);
    setApplyToPropertyOrUnit(false);
    setApplyToComplex(false);
    setApplyToManagement(false);
    setApplyToCourt(false);

    if(!e.target.value) {
      setApplyToPropertyOrUnit(true);
      return;
    }

    switch (e.target.name) {
      case "asset":
        setApplyToAsset(!applyToAsset);
        setUnitId("");
        setCourt("")
        setComplex("")
        break;
      case "unit":
        setApplyToPropertyOrUnit(true);
        setCourt("")
        setComplex("")
        break;
      case "complex":
        setApplyToComplex(true);
        setUnitId("");
        setCourt("")
        break;
      case "court":
        setApplyToCourt(true);
        setUnitId("");
        setComplex("")
        break;
      case "management":
        setApplyToManagement(true);
        setUnitId("");
        setCourt("")
        setComplex("")
        break;
      default:
        break;
    }
  }

  const saveBill = () => {
    props.saveBill(selectedBill);
  };

  const handleCancel = () => {
    props.handleClose();
  };

  const handleItemRemove = (index, billItems, vendorExpenseAccountOptions) => {
    let tmp = billItems;
    if (tmp[index]?.applyVAT) {
      let vatItemIndex = billItemsHash.current[index];
      if (vatItemIndex) {
        tmp.splice(vatItemIndex, 1);
        const newHash = { ...billItemsHash.current };
        delete newHash[index];
        Object.entries(newHash).forEach(([key, value]) => {
          let newKey = key;
          let newValue = key;
          if (parseInt(key) > index || parseInt(value) > index) {
            delete newHash[key];
          }
          if (parseInt(key) > index || parseInt(value) > index) {
            newKey = Math.max(parseInt(key) - 2, 0);
          }
          if (parseInt(value) > index) {
            newValue = Math.max(parseInt(value) - 2, 0);
          }
          newHash[newKey] = newValue;
        });
        billItemsHash.current = newHash;
      }
      tmp.splice(index, 1);
      setBillItems(tmp);
    } else {
      tmp.splice(index, 1);
      const newHash = { ...billItemsHash.current };
      setBillItems(tmp);
      Object.entries(newHash).forEach(([key, value]) => {
        let newKey = key;
        let newValue = key;
        if (parseInt(key) > index || parseInt(value) > index) {
          delete newHash[key];
        }
        if (parseInt(key) > index) {
          newKey = Math.max(parseInt(key) - 1, 0);
        }
        if (parseInt(value) > index) {
          newValue = Math.max(parseInt(value) - 1, 0);
        }
        newHash[newKey] = newValue;
      });
      billItemsHash.current = newHash;
    }
    populateBillItems(tmp, vendorExpenseAccountOptions);
  };

  const handleVendorChange = (vendorId) => {
    setVendorId(vendorId);
    setBillItems([]); // Since we have changed the vendor, first Remove previous items for other vendor. To Avoid mix up because a vendor has  expense acc they are linked to.
  };

  const onBillItemTextChange = (
    event,
    index,
    billItems,
    vendorExpenseAccountOptions
  ) => {
    const id = event.target.id;
    let value = event.target.value;
    let tmp = billItems;
    if (id === "amount" + index) {
      value = tryParseFloat(event.target.value, 0);
      tmp[index].amount = value;
      tmp = findAndUpdateBillItemVAT(tmp[index], index, tmp);
      populateBillItems(tmp, vendorExpenseAccountOptions);
    } else if (id === "notes" + index) {
      tmp[index].notes = value;
      tmp = findAndUpdateBillItemVAT(tmp[index], index, tmp);
      populateBillItems(tmp, vendorExpenseAccountOptions);
    }
    setBillItems(tmp);
  };

  const handleVendorAccountChanged = (
    event,
    index,
    billItems,
    vendorExpenseAccountOptions
  ) => {
    let tmp = billItems;
    let value = event.target.value;
    tmp[index].accountId = value;
    if (withholdingTaxAccountId.current === value) {
      let amount = tryParseFloat(tmp[index].amount, 0);
      tmp[index].isWithholdingTax = true;
      tmp[index].amount = amount;
      tmp[index].notes =
        "Withholding Tax for Bill #" + selectedBill.referenceNumber;
    }
    setBillItems(tmp);
    populateBillItems(tmp, vendorExpenseAccountOptions);
  };

  const handleBillItemAdd = () => {
    if (isNullUndefined(vendorId) || isEmptyString(vendorId)) {
      issueWarnMessage("You must select a vendor before adding bill items");
    } else {
      if (
        billItems.filter((x) => x.accountId === withholdingTaxAccountId.current)
          .length > 1
      ) {
        issueWarnMessage("There should be only one withholding tax line item.");
      } else {
        let tmp = billItems;
        tmp.push({
          id: null,
          accountId: "",
          notes: "",
          amount: "",
          applyVAT: false,
          isTax: false,
        });
        setBillItems(tmp);
        populateBillItems(tmp, vendorExpenseAccountOptions);
      }
    }
  };

  const handleBillTaxableToggle = (
    event,
    index,
    billItems,
    vendorExpenseAccountOptions
  ) => {
    let tmp = billItems;
    let detailItem = tmp[index];
    if (isNullUndefined(detailItem.amount) || detailItem.amount === "0") {
      issueWarnMessage("You must enter an amount before applying VAT");
    } else {
      if (event.target.checked) {
        let vatNotes = "VAT (16%) - " + detailItem.notes;
        let vatAmount = getVATAmount(detailItem.amount);
        tmp.push({
          id: null,
          accountId: VATAccountId.current,
          notes: vatNotes,
          amount: vatAmount,
          applyVAT: false,
          isTax: true,
        });
        detailItem.applyVAT = true;
        if (billItemsHash.current[index] === undefined) {
          billItemsHash.current = billItemsHash.current = {
            ...billItemsHash.current,
            [index]: tmp.length - 1,
          };
        }
      } else {
        findAndRemoveBillVAT(index, billItems, vendorExpenseAccountOptions);
        detailItem.applyVAT = false;
      }
    }

    setBillItems(tmp);
    populateBillItems(tmp, vendorExpenseAccountOptions);
  };

  const findAndRemoveBillVAT = (
    index,
    billItems,
    vendorExpenseAccountOptions
  ) => {
    let vatItemIndex = billItemsHash.current[index];
    if (vatItemIndex) {
      const newHash = { ...billItemsHash.current };
      delete newHash[index];
      billItemsHash.current = newHash;
    }
    handleItemRemove(vatItemIndex, billItems, vendorExpenseAccountOptions);
  };

  const findAndUpdateBillItemVAT = (detailItem, index, items) => {
    let vatAmount = getVATAmount(detailItem.amount);
    let vatItemIndex = billItemsHash.current[index];
    let vatItem = items[vatItemIndex];

    if (vatItem) {
      vatItem.notes = "VAT (16%) - " + detailItem.notes;
      vatItem.amount = vatAmount;
      items[vatItemIndex] = vatItem;
    }
    return items;
  };

  const getVATAmount = (amount) => {
    if (isNaN(amount)) {
      issueWarnMessage("Only numeric amounts are allowed for VAT calculation");
    } else {
      return (amount * 0.16).toFixed(2);
    }
  };

  const populateBillItems = useCallback(
    (billItems, vendorExpenseAccountOptions) => {
      let rows = "";
      let billTotal = 0;
      setBillItems(billItems);
      billItems &&
        billItems.length > 0 &&
        (rows = billItems.map((billItem, i) => {
          let isWithholding =
            billItem.accountId === withholdingTaxAccountId.current;
          if (!isWithholding) {
            billTotal += tryParseFloat(billItem.amount, 0);
          }
          return (
            <TableRow key={i}>
              {vendorExpenseAccountOptions &&
                vendorExpenseAccountOptions.length > 0 && (
                  <TableCell>
                    <Select
                      sx={{ width: "90%" }}
                      id={"account" + i}
                      value={billItems[i].accountId}
                      disabled={billItems[i].isTax}
                      onChange={(event) =>
                        handleVendorAccountChanged(
                          event,
                          i,
                          billItems,
                          vendorExpenseAccountOptions
                        )
                      }
                    >
                      {vendorExpenseAccountOptions &&
                      vendorExpenseAccountOptions.length > 0 ? (
                        vendorExpenseAccountOptions.map((account, i) => {
                          let disabled = false;
                          for (let bill of billItems) {
                            if (
                              account.value ===
                                withholdingTaxAccountId.current &&
                              bill.accountId === withholdingTaxAccountId.current
                            ) {
                              disabled = true;
                            }
                          }
                          return (
                            <MenuItem
                              key={i}
                              disabled={disabled}
                              value={account.value}
                            >
                              {account.label}
                            </MenuItem>
                          );
                        }, this)
                      ) : (
                        <MenuItem sx={{ width: "100%" }}>
                          No Results Found
                        </MenuItem>
                      )}
                    </Select>
                  </TableCell>
                )}

              <TableCell>
                <TextField
                  sx={{ width: "90%" }}
                  id={"notes" + i}
                  placeholder={"Memo"}
                  value={billItems[i].notes}
                  disabled={billItems[i].isTax}
                  onChange={(event) =>
                    onBillItemTextChange(
                      event,
                      i,
                      billItems,
                      vendorExpenseAccountOptions
                    )
                  }
                />
              </TableCell>
              <TableCell>
                <TextField
                  sx={{ width: "90%" }}
                  id={"amount" + i}
                  placeholder={"Amount"}
                  value={billItems[i].amount}
                  disabled={billItems[i].isTax}
                  onChange={(event) =>
                    onBillItemTextChange(
                      event,
                      i,
                      billItems,
                      vendorExpenseAccountOptions
                    )
                  }
                />
              </TableCell>

              <TableCell>
                {!billItems[i].isTax && !billItems[i].isWithholdingTax && (
                  <Checkbox
                    checked={billItems[i].applyVAT}
                    disabled={
                      isNullUndefined(billItems[i].amount) ||
                      isEmptyString(billItems[i].amount) ||
                      billItems[i].amount < 1 ||
                      billItems[i].notes.length < 1
                    }
                    onChange={(event) =>
                      handleBillTaxableToggle(
                        event,
                        i,
                        billItems,
                        vendorExpenseAccountOptions
                      )
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                )}
              </TableCell>
              <TableCell>
                {!billItems[i].isTax && (
                  <IconButton
                    onClick={() =>
                      handleItemRemove(
                        i,
                        billItems,
                        vendorExpenseAccountOptions
                      )
                    }
                    sx={{
                      marginLeft: "-25px",
                      color: "red",
                      fontSize: "5rem",
                      textAlign: "center",
                      fontWeight: 800,
                    }}
                  >
                    <Delete />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          );
        }, this));
      setBillItemTableRows(rows);
      setBillItemTotal(billTotal);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    []
  );

  const renderPropertyForm = () => {
    const selectedUnitOption =
      unitOptions.find((unit) => unit.value === unitId) || null;

    return (
      <ResponsiveRow
        sx={{
          width: "100%",
          height: "auto",
          flexWrap: { xs: "wrap", lg: "nowrap" },
        }}
      >
        <FormControl
          required={true}
          sx={{
            width: { xs: "100%", lg: "50%" },
            margin: "10px",
            padding: "auto 10px",
          }}
        >
          {/* required */}
          <InputLabel id="bill-payee-label">Property</InputLabel>
          {facilityOptions && facilityOptions.length > 0 && (
            <Select
              labelId="bill-property-label"
              id="bill-property"
              value={propertyId}
              label="Property"
              disabled={
                !isNullUndefined(propertyId) && !isEmptyString(propertyId)
              }
              onChange={(e) => {
                setPropertyId(e.target.value);
                setUnitId("");
              }}
              sx={{ width: { xs: "100%", lg: "90%" } }}
            >
              <MenuItem value={""} disabled>
                Select Facility
              </MenuItem>
              {facilityOptions && facilityOptions.length > 0 ? (
                facilityOptions.map((facility, i) => {
                  return (
                    <MenuItem key={i} value={facility.value}>
                      {facility.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          )}
        </FormControl>
        <Autocomplete
          id="bill-unit"
          options={unitOptions}
          value={selectedUnitOption}
          onChange={(_, newValue) =>
            setUnitId(isNullUndefined(newValue) ? "" : newValue.value)
          }
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          noOptionsText="No results found"
          sx={{
            width: { xs: "100%", lg: "50%" },
            margin: "auto 10px",
            padding: "auto 10px",
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Unit"
              placeholder="Select Unit"
              sx={{ width: { xs: "100%", lg: "90%" } }}
            />
          )}
        />
      </ResponsiveRow>
    );
  };

  useEffect(() => {
    if (!isNullUndefined(propertyId) && !isEmptyString(propertyId)) {
      getAllUnitOptions(propertyId).then((opts) => {
        setUnitOptions(opts);
        setUnitId((current) =>
          !isEmptyString(current) &&
          !opts.some((unit) => String(unit.value) === String(current))
            ? ""
            : current
        );
      });
    } else {
      setUnitOptions([]);
    }
  }, [propertyId]);

  useEffect(() => {
    if (
      vendorId !== "" &&
      dueDate !== "" &&
      memo !== "" &&
      billItems.length > 0
    ) {
      if(applyToPropertyOrUnit) {
        if(propertyId === "") {
          setCompletedForm(false);
        } else {
          setCompletedForm(true);
        }
      } else if(applyToAsset) {
        if(asset === "") {
          setCompletedForm(false);
        } else {
          setCompletedForm(true);
        }
      } else if(applyToComplex) {
        if(complex === "") {
          setCompletedForm(false);
        } else {
          setCompletedForm(true);
        }
      }else if(applyToCourt) {
        if(court === "") {
          setCompletedForm(false);
        } else {
          setCompletedForm(true);
        }
      } else if(applyToManagement) {
        setCompletedForm(true)
      } else {
        setCompletedForm(false)
      }
    }

    return () => {
      setCompletedForm(false);
    };
  }, [
    dueDate,
    applyToPropertyOrUnit,
    applyToAsset,
    applyToComplex,
      applyToCourt,
    applyToManagement,
    asset,
    memo,
    complex,
      court,
    vendorId,
    propertyId,
    unitId,
    billItems.length,
  ]);

  useEffect(() => {
    if (props.task === "edit") {
      setVendorId(selectedBill?.vendorId ?? "");
      const dueStr = selectedBill?.dueDate;
      let parsedDue = null;
      if (
        !isNullUndefined(dueStr) &&
        !isEmptyString(dueStr) &&
        typeof dueStr === "string"
      ) {
        const parts = dueStr.trim().split("/");
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          if (
            !Number.isNaN(day) &&
            !Number.isNaN(month) &&
            !Number.isNaN(year)
          ) {
            parsedDue = dayjs(
              `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
            );
          }
        }
      }
      setDueDate(parsedDue && parsedDue.isValid() ? parsedDue : "");
      setVendorRefNo(selectedBill?.vendorRefNo);
      setMemo(selectedBill?.description);
      const fid = selectedBill?.facility?.id;
      setPropertyId(
        !isNullUndefined(fid) && !isEmptyString(fid) ? String(fid) : ""
      );
      const uid = selectedBill?.unit?.id;
      setUnitId(
        !isNullUndefined(uid) && !isEmptyString(uid) ? String(uid) : ""
      );
      const aid = selectedBill?.asset?.id;
      setAsset(
        !isNullUndefined(aid) && !isEmptyString(aid) ? String(aid) : ""
      );
      const cid = selectedBill?.complexId;
      setComplex(
        !isNullUndefined(cid) && !isEmptyString(cid) ? String(cid) : ""
      );
      const ctid = selectedBill?.courtId;
      setCourt(
          !isNullUndefined(ctid) && !isEmptyString(ctid) ? String(ctid) : ""
      );
      setApplyToAsset(false);
      setApplyToPropertyOrUnit(false);
      setApplyToComplex(false);
      setApplyToCourt(false);
      setApplyToManagement(false);
      if (selectedBill?.forAsset) {
        setApplyToAsset(true);
      } else if (selectedBill?.forComplex) {
        setApplyToComplex(true);
      } else if (!isNullUndefined(selectedBill?.courtId) && !isEmptyString(selectedBill?.courtId)) {
        setApplyToCourt(true);
      } else if (selectedBill?.forSubscription) {
        setApplyToManagement(true);
      } else {
        setApplyToPropertyOrUnit(true);
      }
      setBillItems(selectedBill?.billItems ?? []);
    }

    getVendorOptions().then((vendorOptions) => {
      setVendorOptions(vendorOptions);
    });

    getFacilityOptions().then((facilityOptions) =>
      setFacilityOptions(facilityOptions)
    );

    getActiveComplexForOrgOptions().then((complexes) => {
      setComplexOptions(complexes)
    })

    getAssetOptions().then((assetOptions) => {
      setAssetOptions(assetOptions);
    });

    getVATAccount().then((account) => {
      VATAccountId.current = account.id;
    });

    getWithholdingTaxAccount().then((account) => {
      withholdingTaxAccountId.current = account.id;
    });
  }, [props.task, selectedBill]);

  useEffect(() => {
    if (!isEmptyString(vendorId)) {
      getVATAccount().then((account) => {
        VATAccountId.current = account.id;
      });
      getWithholdingTaxAccount().then((account) => {
        withholdingTaxAccountId.current = account.id;
      });
      getVendorExpenseAccountOptions(vendorId).then(
        (vendorExpenseAccountOptions) => {
          setVendorExpenseAccountOptions(vendorExpenseAccountOptions);
          setVendorId(vendorId);
          populateBillItems(billItems, vendorExpenseAccountOptions);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorId]);
  const renderAssetForm = () => {
    return (
      <Fragment>
        <FormControl
          sx={{
            width: { xs: "100%", lg: "50%" },
            margin: "10px",
            padding: "auto 10px",
          }}
        >
          <InputLabel id="bill-asset-label">Asset</InputLabel>
          <Select
            labelId="bill-asset-label"
            id="bill-asset"
            value={asset}
            label="Asset"
            onChange={(e) => setAsset(e.target.value)}
          >
            <MenuItem value={""} disabled>
              Select Asset
            </MenuItem>
            {assetOptions && assetOptions.length > 0 ? (
              assetOptions.map((asset, i) => {
                return (
                  <MenuItem key={i} value={asset.value}>
                    {asset.label}
                  </MenuItem>
                );
              }, this)
            ) : (
              <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
            )}
          </Select>
        </FormControl>
      </Fragment>
    );
  };
  const renderComplexForm = () => {
    return (
      <Fragment>
        <FormControl
          required={true}
          sx={{
            width: { xs: "100%", lg: "50%" },
            margin: "10px",
            padding: "auto 10px",
          }}
        >
          {/* required */}
          <InputLabel id="bill-complex-label">Complex</InputLabel>
          <Select
            labelId="bill-complex-label"
            id="bill-complex"
            value={complex}
            label="Complex"
            onChange={(e) => setComplex(e.target.value)}
          >
            <MenuItem value={""} disabled>
              Select Complex
            </MenuItem>
            {complexOptions && complexOptions.length > 0 ? (
              complexOptions.map((c, i) => {
                return (
                  <MenuItem key={i} value={c.value}>
                    {c.label}
                  </MenuItem>
                );
              }, this)
            ) : (
              <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
            )}
          </Select>
        </FormControl>
      </Fragment>
    );
  };

  const renderCourtForm = () => {
    return (
        <Fragment>
          <FormControl
              required={true}
              sx={{
                width: { xs: "100%", lg: "50%" },
                margin: "10px",
                padding: "auto 10px",
              }}
          >
            {/* required */}
            <InputLabel id="bill-court-label">Court</InputLabel>
            <Select
                labelId="bill-court-label"
                id="bill-court"
                value={court}
                label="Court"
                onChange={(e) => setCourt(e.target.value)}
            >
              <MenuItem value={""} disabled>
                Select Court
              </MenuItem>
              {courtOptions && courtOptions.length > 0 ? (
                  courtOptions.map((c, i) => {
                    return (
                        <MenuItem key={i} value={c.value}>
                          {c.label}
                        </MenuItem>
                    );
                  }, this)
              ) : (
                  <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>
        </Fragment>
    );
  };

  return (
    <ModalContainerModule
      // size="specialCreateBill"
      size="md"
      accept={handleSave}
      cancel={handleCancel}
      openModal={props.openModal}
      modalTitle={props?.task === "edit" ? " Edit Bill" : "Create New Bill"}
      acceptButtonText="Save"
      acceptDisabled={!completedForm}
    >
      <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: 700 }}>
        Bill Details
      </Typography>
      <ResponsiveRow
        sx={{
          alignItems: "flex-start",
          justifyContent: { xs: "center", lg: "space-between" },
          width: "100%",
          height: "auto",
          padding: "0 auto 10px auto ",
        }}
      >
        <FormControl
          required={true}
          sx={{
            width: { xs: "100%", lg: "30%" },
            marginBottom: "10px",
          }}
        >
          {/* required */}
          <InputLabel id="bill-payee-label">Pay To</InputLabel>
          {vendorOptions && vendorOptions.length > 0 && (
            <Select
              labelId="bill-payee-label"
              id="bill-payee"
              value={vendorId}
              label="Pay To"
              sx={{ width: { xs: "100%", lg: "90%" } }}
              onChange={(e) => handleVendorChange(e.target.value)}
            >
              {vendorOptions && vendorOptions.length > 0 ? (
                vendorOptions.map((vendor, i) => {
                  return (
                    <MenuItem key={i} value={vendor.value}>
                      {vendor.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          )}
        </FormControl>
        <FormControl
          required={true}
          sx={{
            width: { xs: "100%", lg: "30%" },
            marginBottom: "10px",
          }}
        >
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en-gb"
          >
            <DatePicker
              id={props.componentID}
              label={props.labelText ? props.labelText : "Date"}
              slotProps={{ textField: { required: true }}}
              sx={{
                margin: "auto",
                width: {
                  xs: "100%",
                  lg: "90%",
                },
                backgroundColor: "#fff",
                borderRadius: "10px",
              }}
              openTo="day"
              InputLabelProps={{
                shrink: true,
              }}
              value={dueDate && dayjs(dueDate)}
              inputFormat="dd/MMM/yyyy"
              disableFuture={true}
              maxDate={dayjs()}
              onChange={(new_value) => setDueDate(new_value)}
            />
          </LocalizationProvider>
        </FormControl>

        <FormControl
          sx={{
            width: { xs: "100%", lg: "30%" },
            marginBottom: "10px",
          }}
        >
          <InputLabel id="bill-vendorRefNo-label">Vendor Ref No.</InputLabel>
          <OutlinedInput
            label="Vendor Ref No."
            labelId="bill-vendorRefNo-label"
            sx={{ width: { xs: "100%", lg: "90%" } }}
            id={"vendorRefNo"}
            value={vendorRefNo}
            onChange={(event) => setVendorRefNo(event.target.value)}
            inputProps={<TextField sx={{ width: { xs: "100%", lg: "90%" } }} />}
          />
        </FormControl>
        <FormControl
          sx={{
            width: { xs: "100%" },
            marginBottom: "10px",
          }}
        >
          <InputLabel id="bill-memo-label" required>Memo</InputLabel>
          <OutlinedInput
            sx={{ width: { xs: "100%", lg: "95%" } }}
            labelId="bill-memo-label"
            id="bill-memo"
            value={memo}
            label="Memo"
            onChange={(e) => setMemo(e.target.value)}
            multiline
            rows={4}
          />
        </FormControl>
      </ResponsiveRow>
      <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: 700 }}>
        Bill To
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: { xs: "space-between", lg: "flex-start" },
          width: "100%",
          padding: "0 10px",
        }}
      >
        <Alert severity="info" sx={{ width: "100%", marginBottom: "10px" }}>
          A bill can only be applied to one area.
        </Alert>
        <ResponsiveRow
          sx={{
            alignItems: "center",
            justifyContent: { xs: "space-between", lg: "flex-start" },
            width: "100%",
            height: "auto",
          }}
          component={FormGroup}
        >
          <FormControl component="fieldset" variant="standard">
            <FormLabel component="legend">Apply To:</FormLabel>
            <FormGroup sx={{display: "flex", flexDirection: "row"}}>
              <FormControlLabel
                control={
                  <Switch checked={applyToAsset} onChange={handleApplyToChange} name="asset" />
                }
                label="Asset"
                sx={{mr: 2}}
              />
              <FormControlLabel
                control={
                  <Switch checked={applyToPropertyOrUnit} onChange={handleApplyToChange} name="unit" />
                }
                label="Property/Unit"
                sx={{mr: 2}}
              />
              <FormControlLabel
                control={
                  <Switch checked={applyToComplex} onChange={handleApplyToChange} name="complex" />
                }
                label="Complex"
                sx={{mr: 2}}
              />
              <FormControlLabel
                  control={
                    <Switch checked={applyToCourt} onChange={handleApplyToChange} name="court" />
                  }
                  label="Court"
                  sx={{mr: 2}}
              />
              <FormControlLabel
                control={
                  <Switch checked={applyToManagement} onChange={handleApplyToChange} name="management" />
                }
                label="Management"
              />
            </FormGroup>
          </FormControl>
        </ResponsiveRow>
      </Box>
      <ResponsiveRow
        sx={{
          height: "auto",
          alignItems: "flex-start",
          justifyContent: { xs: "space-between", lg: "flex-start" },
          width: "100%",
          padding: "10px",
        }}
      >
        {applyToAsset && renderAssetForm()}
        {applyToPropertyOrUnit && renderPropertyForm()}
        {applyToComplex && renderComplexForm()}
        {applyToCourt && renderCourtForm()}
      </ResponsiveRow>
      <ResponsiveRow
        variant=""
        sx={{ height: "auto", width: "100%", padding: "10px" }}
      >
        <Typography
          sx={{ marginBottom: "5px" }}
          id="modal-modal-title"
          variant="h6"
          component="h6"
        >
          Bill Items (Transactions)
        </Typography>

        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ width: "25%", color: "#037171", fontSize: "1rem" }}
                >
                  Expense Account *
                </TableCell>
                <TableCell
                  sx={{ width: "35%", color: "#037171", fontSize: "1rem" }}
                >
                  Memo
                </TableCell>
                <TableCell
                  sx={{ width: "20%", color: "#037171", fontSize: "1rem" }}
                >
                  Amount *
                </TableCell>
                <TableCell
                  sx={{ width: "15%", color: "#037171", fontSize: "1rem" }}
                >
                  Apply VAT (16%)
                </TableCell>
                <TableCell
                  sx={{ width: "5%", color: "#037171", fontSize: "1rem" }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{billItemTableRows}</TableBody>
          </Table>
        </TableContainer>
        <ResponsiveRow
          sx={{
            width: "50%",
            justifyContent: { xs: "center", lg: "flex-start" },
          }}
        >
          <Typography
            sx={{ marginBottom: "5px" }}
            id="modal-modal-title"
            variant="h6"
            component="h6"
          >
            Total: {formatCurrency(billItemTotal)}
          </Typography>
        </ResponsiveRow>
        <ResponsiveRow
          sx={{
            width: "50%",
            justifyContent: { xs: "center", lg: "flex-end" },
          }}
        >
          <ModalAcceptButton
            variant="contained"
            type="submit"
            onClick={handleBillItemAdd}
            disabled={isNullUndefined(vendorId) || isEmptyString(vendorId)}
            sx={{
              width: { xs: "100%", lg: "200px" },
            }}
          >
            Add Row
          </ModalAcceptButton>
        </ResponsiveRow>
      </ResponsiveRow>
    </ModalContainerModule>
  );
}
